/**
 * Component to render the gigya ratings summary
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import noop from 'lodash/noop';
import Button from '@nerdwallet/react-button';
import GigyaRating from './rating';
import PercentageBar from './percentage-bar';

var RatingSummary = function RatingSummary(props) {
  // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
  var rating = get(props.gigya, "ratings[".concat(props.streamID, "]"));
  var ratingCount = get(rating, 'ratingCount', 0);
  var ratingDetails = get(rating, 'ratingDetails');
  var overall = get(ratingDetails, '_overall');
  var average = get(overall, 'avg', 0);
  var scoreBreakdown = get(overall, 'ratings', [0, 0, 0, 0, 0]);
  var numStarsContent = scoreBreakdown.map(function (count, index) {
    var numStars = index + 1;
    numStars += numStars > 1 ? ' stars' : ' star';
    return (// eslint-disable-next-line react/no-array-index-key -- directive added automatically by Shepherd migration
      React.createElement("div", {
        className: "num-stars",
        key: "num-stars-".concat(index)
      }, numStars)
    );
  });
  var percentBarContent = scoreBreakdown.map(function (count, index) {
    return React.createElement(PercentageBar // eslint-disable-next-line react/no-array-index-key -- directive added automatically by Shepherd migration
    , {
      key: "percent-bar-".concat(index),
      total: ratingCount,
      portion: count
    });
  });
  var countContent = scoreBreakdown.map(function (count, index) {
    return (// eslint-disable-next-line react/no-array-index-key -- directive added automatically by Shepherd migration
      React.createElement("div", {
        className: "count",
        key: "count-".concat(index)
      }, count)
    );
  });
  return React.createElement("div", {
    className: "rating-summary"
  }, React.createElement("div", {
    className: "overall-score-summary"
  }, React.createElement("h3", null, "Overall"), React.createElement("div", {
    className: "overall-star-rating"
  }, React.createElement(GigyaRating // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
  , {
    streamID: props.streamID,
    enableHref: false // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    ,
    shouldShowTabDesign: props.shouldShowTabDesign
  })), React.createElement("div", {
    className: "overall-average"
  }, average || 'No rating')), React.createElement("div", {
    className: "overall-score-breakdown"
  }, React.createElement("div", {
    className: "num-stars-container"
  }, numStarsContent.reverse()), React.createElement("div", {
    className: "percent-bar-container"
  }, percentBarContent.reverse()), React.createElement("div", {
    className: "count-container"
  }, countContent.reverse())), props.showWriteReview ? React.createElement("div", {
    className: "write-review-container"
  }, React.createElement("div", {
    className: "write-review"
  }, React.createElement("p", {
    className: "header-text"
  }, props.reviewHeaderText), React.createElement(Button, {
    className: "review-button" // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    ,
    onClick: props.reviewButtonOnClick
  }, "Write a review"))) : null);
};

RatingSummary.displayName = 'Gigya Rating Summary';
RatingSummary.propTypes = {
  streamID: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  gigya: PropTypes.object,
  showWriteReview: PropTypes.bool,
  reviewHeaderText: PropTypes.string,
  reviewButtonOnClick: PropTypes.func,
  shouldShowTabDesign: PropTypes.bool
};
RatingSummary.defaultProps = {
  showWriteReview: false,
  reviewHeaderText: null,
  reviewButtonOnClick: noop,
  shouldShowTabDesign: false
};
export default connect(function (state) {
  return {
    gigya: state.gigya
  };
})(RatingSummary);